<template>
<m-pageframe
    title="Regulatory Compliance"
>
<v-container>

<div
    style="text-align: center"
>
    <div
        v-for="(item, key) in items" 
        :key="key"
    >
        <v-btn
            style="width: 100%; margin-bottom: 12px; max-width: 960px"
            v-on:click="goto(item)"
        >
            {{item.name}}
        </v-btn>
    </div>
</div>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            items: [
                { name: 'Export Communication Log', 'page_name' : 'compliance-export-communications-log' },
                { name: 'Compliance Archives', 'page_name' : 'compliance-archives' },
            ],
        }
    },

    methods: {
        goto(item) 
        {
            this.$router.push({
                'name': item.page_name,
                'params' : {
                    'organization_id' : this.$route.params.organization_id
                }
            }).catch(e=>{}); // swallow any exception
        }
    },
}
</script>

<style lang="scss" scoped>
</style>